import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gp-graphite text-white">
      <div className="px-4 sm:px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div>
                <span className="font-display text-lg font-bold tracking-wider block">GRUPO PILAR</span>
                <span className="font-display text-lg font-bold tracking-wider block">DURA<span className="text-df-orange">FLOW</span></span>
                <span className="text-[10px] text-steel uppercase tracking-[0.2em]">Soluções Hidráulicas</span>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Há mais de 18 anos fornecendo soluções em manutenção industrial, hidráulica industrial, reparos especializados e locação de equipamentos para os mais diversos segmentos da indústria brasileira, com foco em segurança, confiabilidade e excelência operacional.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href="https://www.linkedin.com/company/40698249/admin/dashboard/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full border border-gray-600 flex items-center justify-center hover:border-gp-yellow hover:text-gp-yellow transition-colors duration-300">
                <i className="ri-linkedin-fill text-sm"></i>
              </a>
              <a href="https://www.instagram.com/pilarservicosindustriais/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full border border-gray-600 flex items-center justify-center hover:border-gp-yellow hover:text-gp-yellow transition-colors duration-300">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="https://www.youtube.com/@duraflow-sh" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full border border-gray-600 flex items-center justify-center hover:border-gp-yellow hover:text-gp-yellow transition-colors duration-300">
                <i className="ri-youtube-fill text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-display text-sm uppercase tracking-wider text-gp-yellow mb-5">Navegação</h4>
            <ul className="space-y-3 text-sm text-gray-400">
              <li><Link to="/oficina" className="hover:text-white transition-colors duration-300">Oficina Especializada</Link></li>
              <li><Link to="/equipamentos-e-componentes" className="hover:text-white transition-colors duration-300">Equipamentos</Link></li>
              <li><Link to="/servicos-de-campo" className="hover:text-white transition-colors duration-300">Serviços de Campo</Link></li>
              <li><Link to="/locacao-equipamentos-industriais" className="hover:text-white transition-colors duration-300">Locação</Link></li>
              <li><Link to="/cases" className="hover:text-white transition-colors duration-300">Cases</Link></li>
              <li><Link to="/contato" className="hover:text-white transition-colors duration-300">Contato</Link></li>
              <li><Link to="/trabalhe-conosco" className="hover:text-white transition-colors duration-300">Trabalhe Conosco</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm uppercase tracking-wider text-gp-yellow mb-5">DURAFLOW</h4>
            <ul className="space-y-3 text-sm text-gray-400">
              <li><Link to="/mangueiras-hidraulicas" className="hover:text-white transition-colors duration-300">Mangueiras Hidráulicas</Link></li>
              <li><Link to="/bombas-hidraulicas" className="hover:text-white transition-colors duration-300">Bombas Hidráulicas</Link></li>
              <li><Link to="/motores-hidraulicos" className="hover:text-white transition-colors duration-300">Motores Hidráulicos</Link></li>
              <li><Link to="/cilindros-hidraulicos" className="hover:text-white transition-colors duration-300">Cilindros Hidráulicos</Link></li>
              <li><Link to="/valvulas-hidraulicas" className="hover:text-white transition-colors duration-300">Válvulas Hidráulicas</Link></li>
              <li><Link to="/acumuladores-hidraulicos" className="hover:text-white transition-colors duration-300">Acumuladores Hidráulicos</Link></li>
              <li><Link to="/manometros-medidores" className="hover:text-white transition-colors duration-300">Manômetros e Medidores</Link></li>
              <li><Link to="/valvulas-de-controle" className="hover:text-white transition-colors duration-300">Válvulas de Controle</Link></li>
              <li><Link to="/acessorios-conexoes" className="hover:text-white transition-colors duration-300">Acessórios e Conexões</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm uppercase tracking-wider text-gp-yellow mb-5">Contato</h4>
            <ul className="space-y-4 text-sm text-gray-400">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-gp-yellow mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                <span>Rua Perobas, 116<br/>Coqueiral - Aracruz - ES</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-whatsapp-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                <a href="https://wa.me/5527993092922" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors duration-300">+55 (27) 99309-2922</a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-mail-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                <a href="mailto:oficina@pilar-aracruz.com.br" className="hover:text-white transition-colors duration-300">oficina@pilar-aracruz.com.br</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-500">
            &copy; 2026 Grupo Pilar. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-6 text-xs text-gray-500">
            <a href="#" className="hover:text-white transition-colors duration-300">Política de Privacidade</a>
            <a href="#" className="hover:text-white transition-colors duration-300">Termos de Uso</a>
          </div>
        </div>
      </div>
    </footer>
  );
}